var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTailwindcss(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70.332,
    height: 42.188,
    viewBox: "0 0 70.332 42.188",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "tailwindcss",
    d: "M35.316.13Q21.249.13,17.733,14.192q5.276-7.031,12.308-5.273c2.675.668,4.587,2.609,6.7,4.757,3.448,3.5,7.438,7.548,16.154,7.548q14.066,0,17.583-14.063-5.274,7.031-12.308,5.274c-2.674-.668-4.586-2.609-6.7-4.757C48.023,4.179,44.032.13,35.316.13ZM17.733,21.223Q3.667,21.223.15,35.286q5.274-7.031,12.308-5.273c2.674.669,4.586,2.609,6.7,4.756,3.448,3.5,7.439,7.549,16.154,7.549q14.067,0,17.583-14.063-5.276,7.031-12.308,5.273c-2.675-.668-4.587-2.609-6.7-4.756C30.439,25.273,26.449,21.223,17.733,21.223Z",
    transform: "translate(-0.15 -0.13)",
    fill: "#06b6d4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailwindcss);
export default __webpack_public_path__ + "static/media/tailwindcss.3c7212a870ebab53f86cb64c96c31c6f.svg";
export { ForwardRef as ReactComponent };